export default "__VITE_ASSET__DJkWQObv__"